import * as React from "react";
import { PriceA11y } from "src/components/flexComponents/Hotels/utils/A11y/priceA11yInterface";
import { Hotel } from "src/typings/microserviceModels/hotels-flex-module";
import { UitkPriceLockup, UitkPriceLockupAlign } from "uitk-react-price-lockup";
import useSubtextPriceLockup from "./useSubtextPriceLockup";

interface PriceLockupSingaporeProps {
  hotel: Hotel;
  align?: UitkPriceLockupAlign;
  className?: string;
  priceA11y?: PriceA11y;
  strikeThroughPrice?: string;
}

export const PriceLockupSingapore = ({
  className,
  hotel,
  priceA11y,
  strikeThroughPrice,
  align,
}: PriceLockupSingaporeProps) => {
  const { formattedPrice: lockupPrice } = hotel;
  const { priceSubtextFirst, priceSubtextStandard } = useSubtextPriceLockup(hotel);

  /* istanbul ignore next */
  const a11yPrice = priceA11y?.getA11yText() || "";

  const props = {
    lockupPrice,
    priceSubtextFirst,
    priceSubtextStandard,
    a11yPrice,
    strikeThroughPrice,
    align,
    className,
    /* This text doesn't need to be localized because it's just for a EXPEDIA_SG */
    priceSubtextBold: "Excludes taxes & fees",
  };

  return <UitkPriceLockup {...props} />;
};

export default PriceLockupSingapore;
